import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const SearchingFilter = ({width,value,handleSearchByFilter}) => {
  return (
    <FormControl 
        //sx={{width:`${width}%`,mb:2}} 
        fullWidth
        margin="dense"
    >
        <InputLabel id="demo-simple-select-standard-label">Search By</InputLabel>
        <Select
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        sx={{ "&:focus": {
                backgroundColor: "#ffffff"
                } 
            }}
            label="Search By" 
            value={value}
            onChange={(event) => handleSearchByFilter(event)}
            name="searchby"
        >
            <MenuItem value="">Select Search By</MenuItem>
            <MenuItem value="1"> CTag / MBDTag</MenuItem>
            <MenuItem value="2"> English Text</MenuItem>
        </Select>
    </FormControl>
  )
}

export default SearchingFilter